<template>
	<AppDialog height="655" dialogName="Onboarding text" width="620">
		<Col class="width-100 height-100 dialog-content flex-justify-space-between pa-6">
			<Col class="overflow-y-auto overflow-x-hidden">
				<PortalAuthSettingsContent v-if="localCustomerAuthSettings" :settings.sync="localCustomerAuthSettings" />
			</Col>
			<div class="dialog-bottom flex-centerize mt-2">
				<AnemicButton class="save-button pa-0" :disabled="isLoading" :loading="isLoading" tile @click="handleSettingsUpdateSubmitted">
					Save
				</AnemicButton>
			</div>
		</Col>
	</AppDialog>
</template>

<script>
import AppDialog from '../AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import PortalAuthSettingsContent from '@/components/dialogs/PortalAuthSettingsDialog/PortalAuthSettingsContent.vue';
import { partialUpdateWorkflowVersionSettings } from '@/store/modules/selectedWorkflow/actions';
import { customerAuthSettings } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'PortalAuthSettingsDialog',
	components: { AppDialog, PortalAuthSettingsContent },
	props: { dialogPromiseHandlers: { type: Object } },
	computed: { ...mapGettersShorthand({ customerAuthSettings }) },
	methods: {
		...mapActionsShorthand({ partialUpdateWorkflowVersionSettings }),
		async handleSettingsUpdateSubmitted() {
			this.isLoading = true;
			try {
				await this.partialUpdateWorkflowVersionSettings(this.localCustomerAuthSettings);
			} finally {
				this.isLoading = false;
			}
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	created() {
		this.localCustomerAuthSettings = JSON.parse(JSON.stringify(this.customerAuthSettings));
	},
	data() {
		return { isLoading: false, localCustomerAuthSettings: null };
	},
};
</script>
<style scoped lang="scss"></style>
